import React from 'react';
import type { RouteObject } from 'react-router-dom';

const CategoryPage = React.lazy(() => import('@/pages/category'));
const EventPage = React.lazy(() => import('@/pages/events/slug'));

export const eventRoutes: RouteObject[] = [
  {
    path: ':slug',
    element: <CategoryPage />,
  },
  {
    path: ':category/:slug',
    element: <EventPage />,
  },
];
